import { InjectionToken } from '@angular/core';

declare global {
  interface Window {
    GGBApplet: any;
  }
}

export const GEOGEBRA_WINDOW = new InjectionToken('WindowToken', {
  providedIn: 'root',
  factory: () => window,
});
